const FIELD_IFRAME_KEYS = [
  "iframe_url",
  "iframeUrl",
  "iframe_link",
  "iframeLink",
  "link_iframe",
  "linkIframe",
  "iframe_src",
  "iframeSrc",
  "url_iframe",
  "urlIframe",
  "iframe",
  "embed_url",
  "embedUrl",
  "viewer_url",
  "viewerUrl",
  "digital_twin_url",
  "digitalTwinUrl",
  "digital_twin",
  "digitalTwin",
];

const IFRAME_KEY_PATTERN = /(iframe|digital.*twin|viewer|embed)/i;

const NESTED_URL_KEYS = [
  "url",
  "src",
  "link",
  "href",
  "file_url",
  "iframe_url",
  "iframeUrl",
];
const FALLBACK_BASE_URL = "https://placeholder.local";

const extractIframeSrc = (value) => {
  if (typeof value !== "string") {
    return null;
  }

  const trimmedValue = value.trim();
  if (!trimmedValue) {
    return null;
  }

  if (!trimmedValue.startsWith("<")) {
    return trimmedValue;
  }

  const iframeSrcMatch = trimmedValue.match(
    /<iframe\b[^>]*\bsrc\s*=\s*["']([^"']+)["'][^>]*>/i,
  );

  return iframeSrcMatch?.[1]?.trim() || null;
};

const extractUrlCandidate = (value) => {
  const directValue = extractIframeSrc(value);
  if (directValue) {
    return directValue;
  }

  if (!value || typeof value !== "object" || Array.isArray(value)) {
    return null;
  }

  for (const key of NESTED_URL_KEYS) {
    const nestedValue = extractIframeSrc(value[key]);

    if (nestedValue) {
      return nestedValue;
    }
  }

  return null;
};

const getBaseUrl = () =>
  typeof window !== "undefined" && window.location?.origin
    ? window.location.origin
    : FALLBACK_BASE_URL;

export const normalizeFieldIframeUrl = (value) => {
  const candidate = extractUrlCandidate(value);

  if (!candidate) {
    return null;
  }

  try {
    const url = new URL(candidate, getBaseUrl());

    if (url.protocol !== "https:" && url.protocol !== "http:") {
      return null;
    }

    return url.href;
  } catch {
    return null;
  }
};

export const getFieldIframeUrl = (field) => {
  if (!field || typeof field !== "object") {
    return null;
  }

  for (const key of FIELD_IFRAME_KEYS) {
    const url = normalizeFieldIframeUrl(field[key]);

    if (url) {
      return url;
    }
  }

  const visitedObjects = new WeakSet();

  const findNestedIframeUrl = (value) => {
    if (!value || typeof value !== "object" || visitedObjects.has(value)) {
      return null;
    }

    visitedObjects.add(value);

    for (const [key, nestedValue] of Object.entries(value)) {
      if (!IFRAME_KEY_PATTERN.test(key)) {
        continue;
      }

      const url = normalizeFieldIframeUrl(nestedValue);

      if (url) {
        return url;
      }
    }

    for (const nestedValue of Object.values(value)) {
      const url = findNestedIframeUrl(nestedValue);

      if (url) {
        return url;
      }
    }

    return null;
  };

  return findNestedIframeUrl(field);
};
